<div class="status-bar" [ngClass]="{ 'mt-[115px]! border-0': userService.showRepairerWarningBanner() }">
  <div class="job-status-container">
    <span class="subtitle-1">{{ job?.lastAssessmentAction }}</span>
    @if (!job?.archived && job?.status !== 'HIDDEN' && job?.status) {
      <div class="job-status body-2" (click)="navigateToBucket(job?.status)">
        {{ jobStatusEnum[job?.status] }}
      </div>
    }
    @if (job?.repairProgressColumn) {
      <div class="job-status body-2" (click)="navigateToBucket('REPAIR_PROGRESS')">
        <span>{{ repairProgressMapping[job?.repairProgressColumn] }}</span>
      </div>
    }
    @if (job?.archived && job?.status !== 'HIDDEN') {
      <div class="job-status body-2 archived">{{ job?.status | humanize | titlecase }} [Archived]</div>
    }
    @if (job?.invoicedAndCostControlledExternally) {
      <div class="job-status body-2">Job invoiced and cost controlled externally</div>
    }
  </div>
  <div>
    <span class="status-label body-2">LAST RECEIVED </span>
    @if (job?.lastReceivedDateTime) {
      <span class="status-date subtitle-1">
        {{ job.lastReceivedDateTime | dateepoch: timezone }} {{ job.lastReceivedDateTime | time: timezone }}
      </span>
    }
    <span>
      <button matIconButton (click)="viewJobHistory()">
        <mat-icon>history</mat-icon>
      </button>
    </span>
  </div>
</div>

<mat-accordion #accordion="matAccordion" [multi]="true">
  <div
    class="main-section"
    [class.margin-bottom-40]="!job?.cancelled"
    [ngClass]="{ 'mt-[160px]!': userService.showRepairerWarningBanner() }">
    <div class="claim-section">
      @if (job?.authority || job?.selfAuthorized) {
        <app-repair-timeline-curtain
          [job]="job"
          [currentTimezone]="timezone"
          (editRepairTimeline)="reviewTimeline($event)"></app-repair-timeline-curtain>
      }
      @if (job) {
        <app-claim-curtain
          [job]="job"
          [currentUserTimezone]="timezone"
          [showBooking]="showBooking"
          [savedJobStatus]="saveJobResponseStatus"
          [shouldCollapseCurtain]="collapseOpenedCurtain"
          (disableSendButton)="disableSendButton = $event"
          (fetchJob)="getJob()"
          (saveJob)="saveJob($event?.fieldValue, $event?.fieldName)"
          (validateSendJob)="receiveClaimCurtainData($event)"
          (inspectionBooking)="performingTask($event)">
        </app-claim-curtain>
      }
      @if (job) {
        <job-contacts
          [cards]="job.cards"
          [ownerEditable]="job?.editable && !userService.isRepairerSiteSuspended()"
          (editOwner)="editContact()" />
      }

      @if (submittedPhotos?.length) {
        <app-gallery-curtain
          (refreshJobViewer)="refresh()"
          (updateSelectedPhoto)="updateSelectedPhoto($event)"
          [job]="job"
          [photos]="submittedPhotos"
          [shouldCollapseCurtain]="collapseOpenedCurtain">
        </app-gallery-curtain>
      }

      @if (submittedDocs?.length) {
        <app-documents-curtain
          (refreshJobViewer)="refresh()"
          [job]="job"
          [docs]="submittedDocs"
          [shouldCollapseCurtain]="collapseOpenedCurtain">
        </app-documents-curtain>
      }

      @if (job?.preAuthority) {
        <app-pre-authority-curtain
          (disableSendButton)="disableSendButton = showValidationGuidance || $event"
          (refreshJobViewer)="refresh()"
          (synchronizeOwnerContribution)="
            job.ownerContribution = $event.ownerContribution;
            synchronizeAuthorityOwnerContribution($event);
            synchronizeInvoiceOwnerContribution($event)
          "
          [editable]="!job?.cancelled"
          [jobId]="job?.jobId"
          [ownerContributionEditable]="!job?.cancelled && !(submittedInvoices.length > 0)"
          [preAuthority]="job?.preAuthority"
          [quoteSubmitted]="submittedQuotes.length > 0"
          (openPdfReport)="openPdfReport('pre_authorized')">
        </app-pre-authority-curtain>
      }

      @if (submittedDiaries?.length) {
        <app-diary-curtain
          [diaries]="submittedDiaries"
          [shouldCollapseCurtain]="collapseOpenedCurtain"></app-diary-curtain>
      }

      @if (
        job?.gicopUI.customerFeedbacks.length ||
        job?.gicopUI.customerContacts.length ||
        job?.gicopUI.codeOfPracticeBreaches.length ||
        job?.gicopUI.customerVulnerabilities.length
      ) {
        <app-gicop-notifications-curtain
          [gicopNotifications]="job?.gicopUI"
          [timezone]="timezone"></app-gicop-notifications-curtain>
      }

      @for (item of submittedItems; track item) {
        <div>
          @if (
            item.type === 'QUOTE' &&
            (!unSubmittedQuote ||
              item.document.authorized ||
              (item.document.assessed &&
                (job.allowSupplementQuote || (item.document.original && submittedItems.length > 1))))
          ) {
            <app-quote-curtain
              [document]="item"
              [isSentToInsurerTray]="false"
              [shouldCollapseCurtain]="collapseOpenedCurtain"
              [quotingSystemName]="job.quotingSystem?.companyName" />
          }
          @if (item.type === 'INVOICE' && !item.document.isPartial) {
            <app-invoice-curtain
              (refreshInvoice)="refresh()"
              [document]="item"
              [isSentToInsurerTray]="false"
              [shouldCollapseCurtain]="collapseOpenedCurtain"
              [repairerSiteId]="job?.repairerSiteId"></app-invoice-curtain>
          }
          @if (item.type === 'INVOICE' && item.document.isPartial) {
            <app-partial-invoice
              [document]="item"
              [repairerSiteId]="job?.repairerSiteId"
              [shouldCollapseCurtain]="collapseOpenedCurtain"></app-partial-invoice>
          }
          @if (item.documentType === 'AUTHORITY') {
            <app-authority-curtain
              (disableSendButton)="disableSendButton = $event"
              (synchronizeOwnerContribution)="
                job.ownerContribution = $event.ownerContribution;
                synchronizeInvoiceOwnerContribution($event);
                synchronizePreAuthorityOwnerContribution($event)
              "
              [authority]="item"
              [editable]="!(submittedInvoices.length > 0) && !job?.cancelled"
              [excessType]="job?.excessType"
              [jobId]="job?.jobId"
              [repairerSiteId]="job?.repairerSiteId"
              [insurer]="insurer"
              [shouldCollapseCurtain]="collapseOpenedCurtain"></app-authority-curtain>
          }
        </div>
      }
    </div>

    @if (
      unSubmittedDocuments?.length ||
      unSubmittedPhotos?.length ||
      unSubmittedDocs?.length ||
      unSubmittedInvoice ||
      unSubmittedDiary ||
      job?.gicopUI?.unsubmittedGicopNotification ||
      noQuoteResponse ||
      showBooking ||
      showSelfAuthorisationCurtain
    ) {
      <div [class.guidance]="showValidationGuidance" class="send-to-insco-section">
        <app-send-to-insco-tabs
          [job]="job"
          [recipient]="job?.cards | skateholdersInfo: 'role' : 'ASSESSOR'"
          [ownerName]="ownerName"
          [unSubmittedDocs]="unSubmittedDocs"
          [unSubmittedPhotos]="unSubmittedPhotos"
          [unSubmittedQuote]="unSubmittedQuote"
          [unSubmittedInvoice]="unSubmittedInvoice"
          [noQuoteResponse]="noQuoteResponse"
          [noQuoteResponseAssessmentAction]="noQuoteResponseAssessmentAction"
          [submittedQuotes]="submittedQuotes"
          [unSubmittedDiary]="unSubmittedDiary"
          [unSubmittedCustomerContact]="unSubmittedCustomerContact"
          [unSubmittedPotentialBreachOfCode]="unSubmittedPotentialBreachOfCode"
          [unSubmittedCustomerVulnerability]="unSubmittedCustomerVulnerability"
          [showSelfAuthorisationCurtain]="showSelfAuthorisationCurtain"
          [submittedQuoteNotAuthorised]="submittedQuoteNotAuthorised"
          [unSubmittedCustomerFeedback]="unSubmittedCustomerFeedback"
          [showValidationGuidance]="showValidationGuidance"
          [showBooking]="showBooking"
          [hasQuotes]="hasQuotes"
          [indexTab]="indexTab"
          [expandCurtainInTray]="expandCurtainInTray"
          (refresh)="refresh($event)"
          (updateSelectedPhoto)="updateSelectedPhoto($event)"
          (validateSendJob)="validateSendJob($event)"
          (openPdfReport)="openPdfReport($event)"
          (disableSendButton)="disableSendButton = $event"
          (synchronizeOwnerContribution)="
            job.ownerContribution = $event.ownerContribution;
            synchronizeAuthorityOwnerContribution($event);
            synchronizePreAuthorityOwnerContribution($event)
          ">
        </app-send-to-insco-tabs>
      </div>
    }
  </div>
  <div class="action-bar">
    <div class="action-bar-content">
      <div class="flex gap-x-10">
        @if (!job?.cancelled) {
          <app-job-tasks
            [job]="job"
            [jobStates]="jobStates"
            [noQuoteResponse]="noQuoteResponse"
            [invoiceCreated]="invoiceCreated"
            [supplementQuote]="supplementQuote"
            [invoicePendingReview]="invoicePendingReview"
            [showBooking]="showBooking"
            [displayAddInvoiceButton]="displayAddInvoiceButton"
            [showSelfAuthorisationCurtain]="showSelfAuthorisationCurtain"
            [unSubmittedQuote]="unSubmittedQuote"
            [ownerName]="ownerName"
            [invoiceButtonMsg]="invoiceButtonMsg"
            [inputFileValue]="inputFileValue"
            [unSubmittedDiary]="unSubmittedDiary"
            (taskButtonClicked)="performingTask($event)">
          </app-job-tasks>
        }

        <app-job-reports [job]="job" [submittedItems]="submittedItems" />
      </div>

      @if (!job?.cancelled) {
        <div>
          @if (
            unSubmittedDocuments?.length ||
            unSubmittedPhotos?.length ||
            unSubmittedDocs?.length ||
            unSubmittedDiary ||
            showBooking ||
            noQuoteResponse ||
            showSelfAuthorisationCurtain ||
            job?.gicopUI?.unsubmittedGicopNotification
          ) {
            <span class="pending-items-guidance body-2">
              {{ countItemsToSend }} {{ countItemsToSend === 1 ? 'item' : 'items' }} pending
            </span>
          }
          <button
            (click)="submitJob()"
            [disabled]="
              disableSendButton ||
              jobViewerStore.hasNegativeUnsubmittedInvoice() ||
              !(
                unSubmittedQuote ||
                unSubmittedPhotos?.length ||
                unSubmittedDocs?.length ||
                unSubmittedInvoice ||
                unSubmittedDiary ||
                noQuoteResponse ||
                showBooking ||
                showSelfAuthorisationCurtain ||
                job?.gicopUI?.unsubmittedGicopNotification
              ) ||
              jobService.displayWarningQuoteTab()
            "
            class="red-button mr-10"
            matButton="elevated">
            <mat-icon>send</mat-icon>
            SEND
          </button>
        </div>
      }

      @if (
        !job?.cancelled &&
        (jobViewerStore.hasNegativeUnsubmittedInvoice() ||
          (showValidationGuidance &&
            (unSubmittedQuote ||
              unSubmittedPhotos?.length ||
              unSubmittedDocs?.length ||
              unSubmittedInvoice ||
              unSubmittedDiary ||
              noQuoteResponse ||
              showBooking ||
              unSubmittedCustomerFeedback ||
              unSubmittedCustomerContact ||
              unSubmittedPotentialBreachOfCode ||
              unSubmittedCustomerVulnerability ||
              isVehicleInfosInvalid)) ||
          jobService.displayWarningQuoteTab())
      ) {
        <div class="incomplete-guidance body-1">
          <mat-icon class="info-outline-icon">info_outline</mat-icon>
          <div class="guidance-text">
            @switch (true) {
              @case (jobViewerStore.hasNegativeUnsubmittedInvoice()) {
                <div class="instructions subtitle-1">
                  The invoice total payable amount must be greater than or equal to $0.00.
                </div>
              }
              @case (jobService.displayWarningQuoteTab()) {
                <div class="instructions subtitle-1">Resolve quoting conflict</div>
                <div class="validationDetails subtitle-1">to send</div>
              }
              @default {
                <div class="instructions subtitle-1">Complete</div>
                <div class="validationDetails subtitle-1" [innerHTML]="validationDetails"></div>
              }
            }
          </div>
        </div>
      }
    </div>
  </div>
</mat-accordion>
